import React from 'react'
import { Modal } from './Modal'
import './ConfirmDialog.css'

/**
 * ConfirmDialog Component
 *
 * Confirmation dialog with customizable actions
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether dialog is open
 * @param {Function} props.onClose - Called when dialog should close
 * @param {Function} props.onConfirm - Called when user confirms
 * @param {string} props.title - Dialog title
 * @param {string} props.message - Dialog message
 * @param {string} [props.confirmText='Confirm'] - Confirm button text
 * @param {string} [props.cancelText='Cancel'] - Cancel button text
 * @param {string} [props.variant='info'] - Dialog variant ('danger', 'warning', 'info')
 */
export const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'info',
}) => {
  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="realm-confirm-dialog">
        <div className="realm-confirm-dialog-header">
          <h3 className="realm-confirm-dialog-title">{title}</h3>
        </div>
        <div className="realm-confirm-dialog-body">
          <p className="realm-confirm-dialog-message">{message}</p>
        </div>
        <div className="realm-confirm-dialog-footer">
          {cancelText && (
            <button className="realm-confirm-dialog-button realm-confirm-dialog-button-cancel" onClick={onClose}>
              {cancelText}
            </button>
          )}
          <button
            className={`realm-confirm-dialog-button realm-confirm-dialog-button-confirm realm-confirm-dialog-button-${variant}`}
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  )
}
